<template>
    <div>
        <buttonlist
                ref="SetBtn"
                @help="help"
        ></buttonlist>
        <div style="width:690px;min-width:690px;margin-top: 5px">
            <tr>
                <td style="width:80px;min-width:80px">{{$t('getapi[4361]')}}</td>
                <td style="width:150px;min-width:150px">
                    <routejump :urlNo="15">
                    <el-input
                            v-model="workcenter_code"
                            type="text"
                            readonly
                            size="mini"
                    >
                        <i class="el-icon-edit el-input__icon" slot="suffix" @click="selectCode"></i>
                    </el-input>
                    </routejump>
                </td>
                <td style="width:80px;min-width:80px">{{$t('getapi[882]')}}</td>
                <td style="width:150px;min-width:150px">
                    <el-input v-model="workcenter_name" size="mini" :readonly="true" class="readO"></el-input>
                </td>
                <td style="width:80px;min-width:80px">{{$t('getapi[6370]')}}</td>
                <td style="width:150px;min-width:150px">
                    <el-input v-model="report_measure_method" size="mini" :readonly="true" class="readO"></el-input>
                </td>
            </tr>
        </div>
        <div id="main" :style="{ width: Cwidth + 'px', height: tableHeight + 'px' }"></div>

        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Pro/MPS/GetWorkCenterPopupDataList'"
                  @callback="getCode" ref="workcentercode"></selector>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import echarts from 'echarts';
    import { Loading } from 'element-ui';

    export default {
        name: '2_actualcapacity',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight2
            },
            Cwidth(){
                return document.getElementById('silderRight') == undefined?1000:document.getElementById('silderRight').clientWidth
            }
        },
        data() {
            const generateData = _ => {
                const data = [];
                return data;
            }
            return {
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: 100, // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                workcenter_code: '',
                workcenter_name: '',
                report_measure_method: '',
                isShowItem:false,
                itemArr:generateData(),
                value: [{key:'CEL',label:'CEL'}],
                option: [],
                rightarr: [],//右侧显示项目
                scrollTop:0,
            };
        },
        watch: {
            'dataSet.dt': function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted: function () {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.VXTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.VXTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[3995]"),this.$t("getapi[26]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetButtonEnable('');
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let parm = {
                    workcenter_code: that.workcenter_code
                }
                let loadingInstance = Loading.service(Common.maskoption1);
                that.$http.urlpost('/Pro/MPS/GetActualCapacity', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        let datalrcn  = []
                        let datalrcnall = []
                        for(let i=0;i<that.dataSet.dt.length;i++){
                            if(that.dataSet.dt[i].Item_Code == '理论产能'){
                                datalrcnall = that.dataSet.dt[i]
                            }
                        }
                        for(let x in datalrcnall){
                            if(x != 'Item_Code' && x != 'SumFlag'){
                                datalrcn = [...datalrcn,datalrcnall[x]]
                            }
                        }
                        that.loading = false;
                        console.log(datalrcn)
                        that.showchar(datalrcn)
                        that.showchar_()
                        that.authority();
                    }
                    loadingInstance.close()
                });
            },
            showchar_(){
                let that = this
                that.cht = echarts.init(document.getElementById("main"));
                that.cht.resize();
                that.value = []
                let arr1 = [] // 过滤掉理论产能
                for(let i =0;i<that.dataSet.dt.length;i++){
                    if(that.dataSet.dt[i].Item_Code != '理论产能') {
                        arr1 = [...arr1, that.dataSet.dt[i]]
                        that.value = [...that.value, that.dataSet.dt[i].Item_Code]
                    }
                }
                console.log(arr1)
                let arr2 = []
                for(let i = 0;i<arr1.length;i++){
                    let arr3 = []
                    for(let x in arr1[i]){
                        if(x != 'Item_Code'){
                            arr3 = [...arr3,arr1[i][x]]
                        }
                    }
                    arr2 = [...arr2,{
                        key: arr1[i].Item_Code,
                        value: arr3
                    }]
                }
                let newOption = JSON.parse(that.defaultOption)
                for(let i = 0;i<that.value.length;i++){
                    for(let j = 0;j<arr2.length;j++){
                        if(that.value[i] == arr2[j].key) {
                            newOption.legend.data.push(arr2[j].key)
                            newOption.series.push({
                                name: arr2[j].key,
                                data: arr2[j].value,
                                type: 'bar',
                                stack: '总量',
                            })

                            arr2.splice(j,1)
                        }
                    }
                }
                console.log(arr2)
                console.log(that.value)
                if(that.value.length > 0){
                    let arrotherval = [0,0,0,0,0,0]
                    for(let i = 0;i<arr2.length;i++){
                        console.log(arr2[i].value[0])
                        arrotherval[0] += (arr2[i].value[0] == null?0:arr2[i].value[0])
                        arrotherval[1] += (arr2[i].value[1] == null?0:arr2[i].value[1])
                        arrotherval[2] += (arr2[i].value[2] == null?0:arr2[i].value[2])
                        arrotherval[3] += (arr2[i].value[3] == null?0:arr2[i].value[3])
                        arrotherval[4] += (arr2[i].value[4] == null?0:arr2[i].value[4])
                        arrotherval[5] += (arr2[i].value[5] == null?0:arr2[i].value[5])
                    }
                    console.log(arrotherval)
                    newOption.legend.data.push(this.$t('getapi[224]'))
                    newOption.series.push({
                        name: this.$t('getapi[224]'),
                        data: arrotherval,
                        type: 'bar',
                        stack: '总量',
                    })
                }
                console.log('newOption' + JSON.stringify(newOption))
                that.cht.clear();
                that.cht.setOption(newOption);
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            //选择工作中心代码
            selectCode() {
                let that = this;
                that.$refs.workcentercode.clearInput(true);
            },
            getCode(val) {
                let that = this;
                console.log(val)
                that.workcenter_code = val.workcenter_code
                that.workcenter_name = val.workcenter_name
                that.report_measure_method = val.report_measure_method
                that.getView()
            },
            showchar(datalrcn) {
                let that = this
                that.cht = echarts.init(document.getElementById("main"));
                that.cht.resize();
                const x = [];
                const today = new Date();
                for (let i = 0; i < 6; i++) {
                    const date = new Date(today.getFullYear(), today.getMonth() + i, 1);
                    const year = date.getFullYear();
                    const month = String(date.getMonth() + 1).padStart(2, '0');
                    x.push(`${year}-${month}`);
                }
                that.option = {
                    xAxis: {
                        type: 'category',
                        data: x
                    },
                    yAxis: {
                        type: 'value'
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        data:['理论产能']
                    },
                    series: [
                        {
                            name: '理论产能',
                            data: datalrcn,
                            type: 'line'
                        }
                    ]
                }
                that.defaultOption = JSON.stringify(that.option)
                that.cht.clear();
                that.cht.setOption(that.option);
            },
            cellstyle({row, column, rowIndex, columnIndex}) {
                let that = this;
                if (columnIndex == 0) {
                    return "background:rgb(237,190,203)"
                }
            },
            handleChange(value, direction, movedKeys){
                console.log(value, direction, movedKeys);
                let that = this
                that.rightarr = value
            },
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
